import React, { Component, Fragment } from 'react';
import { Button, Modal, Select, Input, Divider, InputNumber, List, Icon, Col, Alert, message } from 'antd';
import { GroceryList }  from '../../../../services/api'; 
import { DayOfWeek, MealType } from '../../../../components/Label';
import Spinner from '../../../../components/Spinner';

export default class AddButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: {
                lists: false,
                save: false,
            },
            modalVisible: false,
            disabled: false,
            lists: [],
            links: {},
            listId: null,
            newList: '',
            portions: {},
            meals: {}
        }
        
        if (this.props.recipe) {
            const now = new Date();
            this.state.newList = `Inköpslista ${now.getDate()}/${now.getMonth()}`;
        } else if (this.props.menu) {
            const now = new Date();
            this.state.newList = `${this.props.menu.title} - Inköpslista ${now.getDate()}/${now.getMonth()}`;

        }
        this.groceryListApi = new GroceryList(props);
    }

    componentWillUnmount() {
        this.isCancelled = true;
    }

    fetchGroceryLists = () => {
        const { loading } = this.state;
        loading.lists = true;
        this.setState({ loading });
        this.groceryListApi.all()
            .then(res => {
                if (!this.isCancelled) {
                    loading.lists = false;
                    this.setState({ lists: res.data.data, loading, links: res.data._links });
                }
            })
            .catch(_ => {
                this.groceryListApi.retry({ cb: this.fetchGroceryLists });
            });
    }

    showAddModal = () => {
        this.fetchGroceryLists();
        this.setState({ modalVisible: true });
    }

    onSelectList = (value) => {
        if (value !== undefined) {
            this.setState({ newList: '', listId: value });
        } else {
            const now = new Date();
            let title = `Inköpslista ${now.getDate()}/${now.getMonth()}`;
            if (this.props.menu) {
                const now = new Date();
                title = `${this.props.menu.title} - Inköpslista ${now.getDate()}/${now.getMonth()}`;
            }
            this.setState({ listId: null, newList: title });
        }
    }

    handleOk = () => {
        if (this.state.listId) {
            this.patchList()
            return;
        }
        this.createList();
    }

    handleCancel = () => {
        this.setState({ modalVisible: false });
    }

    createList = () => {
        const recipe = this.props.recipe;
        const { newList, links, portions, loading } = this.state;
        loading.save = true;

        const data = {title: newList, recipes: []};
        if (recipe) {
            data.recipes.push({ id: recipe.id, portions: recipe.portions });
        }
        
        if (portions) {
            Object.keys(portions).forEach(key => {
                data.recipes.push({ id: portions[key].recipe_id, portions: portions[key].portions });
            });
        }

        this.setState({ loading });
        this.groceryListApi.raw().post(links.create.href, data)
            .then(_ => {
                loading.save = false;
                this.setState({ modalVisible: false, loading });
            })
            .catch(_ => {
                this.groceryListApi.retry({ cb: this.createList });
            });
    }

    patchList = () => {
        const recipe = this.props.recipe;
        const { listId, lists, portions, loading } = this.state;
        const index = lists.findIndex(l => l.id === listId);
        const list = lists[index];

        const data = {recipes: []};
        if (recipe) {
            data.recipes.push({ id: recipe.id, portions: recipe.portions });
        }

        if (portions) {
            Object.keys(portions).forEach(key => {
                data.recipes.push({ id: portions[key].recipe_id, portions: portions[key].portions });
            });
        }

        loading.save = true;
        this.setState({ loading });
        this.groceryListApi.raw().patch(list._links.patch.href, data)
            .then(() => {
                loading.save = false;
                this.setState({ modalVisible: false, loading });
            })
            .catch(_ => {
                this.groceryListApi.retry({ cb: this.patchList });
            });
    }

    groupMeals = (meals) => {
        const { portions } = this.state;
        const grouped = {};
        meals.forEach(m => {
            if (!grouped[m.type]) {
                grouped[m.type] = [];
            }

            if (!portions[m.id]) {
                portions[m.id] = { recipe_id: m.recipe.id, portions: 4};
            }
            grouped[m.type].push({id: m.id, recipe: m.recipe, portions: portions[m.id].portions});
        });

        const filtered = {};
        if (grouped['BREAKFAST']) {
            filtered['BREAKFAST'] = grouped['BREAKFAST'];
        }
        if (grouped['LUNCH']) {
            filtered['LUNCH'] = grouped['LUNCH'];
        }
        if (grouped['DINNER']) {
            filtered['DINNER'] = grouped['DINNER'];
        }
        
        return filtered;
    }

    handlePortionChange = (portion, meal) => {
        if (portion < 1) {
            message.error('Ange minst en portion.');
            this.setState({ disabled: true });
        } else {
            this.setState({ disabled: false });
        }

        const { portions } = this.state;
        portions[meal.id] = { recipe_id: meal.recipe.id, portions: portion };
        this.setState({ portions });
    }

    render() {
        const { menu, iconOnly } = this.props;
        const { loading, modalVisible, lists, newList, listId, meals } = this.state;
        
        if (menu) {
            this.props.menu._embedded['varma:days'].data.forEach(d => {
                meals[d.day_of_week] = this.groupMeals(d.meals);
            });
        }
        
        const disabled = (menu && Object.keys(meals).length === 0) || this.state.disabled;
        return (
            <Fragment>
                {iconOnly ? 
                    <Icon type="file-done" onClick={this.showAddModal}/>
                    : (
                        <Button style={this.props.style} type="primary" icon="file-done" onClick={this.showAddModal}>
                            Lägg i inköpslista
                        </Button>
                    )
                }
                
                <Modal
                    title="Lägg i inköpslista"
                    visible={modalVisible}
                    okText="Lägg till"
                    cancelText="Avbryt"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    okButtonProps={{ loading: loading.save, disabled }}
                >
                    {lists.length > 0 && (
                        <Fragment>
                            <Divider style={{ marginTop: 0 }}>Lägg till i befintlig lista</Divider>
                        
                            <Spinner loading={loading.lists} />
                            {!loading.lists && lists.length > 0 && (
                                <Select
                                    showSearch
                                    allowClear={true}
                                    style={{ width: '100%' }}
                                    placeholder="Välj en lista"
                                    optionFilterProp="children"
                                    onChange={this.onSelectList}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {lists.map(l => <Select.Option key={l.id} value={l.id}>{l.title}</Select.Option>)}
                                </Select>
                            )}
                        </Fragment>
                    )}
                    {lists.length === 0 ? <Divider style={{ marginTop: 0 }}>Skapa lista</Divider> : <Divider>..eller skapa ny lista</Divider>}
                    
                    <Input value={newList} disabled={listId !== null} onChange={e => this.setState({ newList: e.target.value })}/>

                    {menu && Object.keys(meals).length === 0 && (
                        <Alert
                            showIcon
                            style={{ marginTop: '20px' }}
                            type="error" 
                            message="Menyn innehåller inga måltider och kan inte läggas till i en inköpslista."
                        />
                    )}
                    {menu && Object.keys(meals).length > 0 && (
                        <div>
                            <Alert
                                showIcon
                                style={{ marginTop: '20px' }}
                                type="info" 
                                message="Nedan kan du ändra antalet portioner för måltiderna i menyn."
                            />
                            {Object.keys(meals).map(dayOfWeek => (
                                <div key={dayOfWeek}>
                                    <Divider><DayOfWeek type={dayOfWeek}/></Divider>
                                    
                                    {Object.keys(meals[dayOfWeek]).map(meal => (
                                        <div key={meal}>
                                            <h4><MealType type={meal} /></h4>
                                            <List 
                                                dataSource={meals[dayOfWeek][meal]}
                                                renderItem={(item, index) => (
                                                    <List.Item>

                                                            <Col span={19}>
                                                                <span>{item.recipe.title}</span>
                                                            </Col>
                                                            <Col span={5}>
                                                                <InputNumber value={item.portions} onChange={e => this.handlePortionChange(e, item)} />
                                                            </Col>

                                                    </List.Item>
                                                )}
                                            />
                                        </div>
                                    ))}
                                </div> 
                            ))}
                        </div>
                    )}
                </Modal>
            </Fragment>
        )
    };
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/components/grocery-list/AddButton.js